(function (window, document) {
  'use strict';

  var CONFIG = {
    allowedOrigins: [
      'https://step2love.com',
      'https://test1.step2love.com',
    ],
    messageType: 'social_auth_cancelled',
    modalId: 'social-auth-cancel-modal',
    modalStyleId: 'social-auth-cancel-modal-style',
    defaultText: 'You have canceled your social login. Please try again or use the form.'
  };
  function isAllowedOrigin(origin) {
    return CONFIG.allowedOrigins.indexOf(origin) !== -1;
  }

  function ensureStyles() {
    if (document.getElementById(CONFIG.modalStyleId)) {
      return;
    }

    var style = document.createElement('style');
    style.id = CONFIG.modalStyleId;
    style.textContent =
      '#' + CONFIG.modalId + ' {' +
      '  display: flex;' +
      '  justify-content: center;' +
      '  align-items: center;' +
      '  position: fixed;' +
      '  z-index: 10000;' +
      '  left: 0;' +
      '  top: 0;' +
      '  width: 100%;' +
      '  height: 100%;' +
      '  background-color: rgba(0, 0, 0, 0.7);' +
      '}' +

      '#' + CONFIG.modalId + ' .social-auth-cancel-modal__content {' +
      '  background-color: #f3eeee;' +
      '  padding: 30px 20px;' +
      '  border-radius: 8px;' +
      '  border: 1px solid rgba(120, 130, 150, 0.25);' +
      '  position: relative;' +
      '  text-align: center;' +
      '  box-shadow: 0 0 20px rgba(70, 84, 110, 0.28);' +
      '  max-width: 420px;' +
      '  width: 90%;' +
      '}' +

      '#' + CONFIG.modalId + ' .social-auth-cancel-modal__close {' +
      '  position: absolute;' +
      '  top: 5px;' +
      '  right: 10px;' +
      '  font-size: 36px;' +
      '  line-height: 1;' +
      '  color: #555;' +
      '  cursor: pointer;' +
      '}' +

      '#' + CONFIG.modalId + ' .social-auth-cancel-modal__close:hover {' +
      '  color: #000;' +
      '}' +

      '#' + CONFIG.modalId + ' .social-auth-cancel-modal__text {' +
      '  font-size: 18px;' +
      '  line-height: 1.4;' +
      '  color: #333;' +
      '  margin: 10px 0 0;' +
      '}';
    document.head.appendChild(style);
  }

function closeModal() {
  var modal = document.getElementById(CONFIG.modalId);
  if (modal && modal.parentNode) {
    modal.parentNode.removeChild(modal);
  }

  document.removeEventListener('keydown', onEscKeyDown);
}

function onEscKeyDown(e) {
  if (e.key === 'Escape' || e.key === 'Esc') {
    closeModal();
  }
}

  function showModal(text) {
    closeModal();
    ensureStyles();

    var modal = document.createElement('div');
    modal.id = CONFIG.modalId;

    var content = document.createElement('div');
    content.className = 'social-auth-cancel-modal__content';

    var close = document.createElement('span');
    close.className = 'social-auth-cancel-modal__close';
    close.innerHTML = '&times;';

    var message = document.createElement('p');
    message.className = 'social-auth-cancel-modal__text';
    message.textContent = text || CONFIG.defaultText;

    close.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    content.appendChild(close);
    content.appendChild(message);
    modal.appendChild(content);
    document.body.appendChild(modal);

    document.addEventListener('keydown', onEscKeyDown);
  }

  window.addEventListener('message', function (event) {
    if (!isAllowedOrigin(event.origin)) {
      return;
    }

    if (!event.data || event.data.type !== CONFIG.messageType) {
      return;
    }

    showModal(event.data.text || CONFIG.defaultText);
  });

})(window, document);